module.exports = __webpack_public_path__ + "static/media/LuckysTreasureCover_454x640.6e08d770.jpg";